// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Bm-z","tupacHeader":"Cm-z","tupacHeader2":"Dm-z","tupacMenu":"Em-z","tupacMenu2":"Fm-z","tupacMain":"Gm-z","tupacMain2":"Hm-z"};